import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/auth'
import { getStore } from '@/utils/store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL // api的base_url
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  const plaintext = config.data
  const body = plaintext
  config.data = body

  config.headers['zo'] = getStore({ name: 'zo' })
  config.headers['timestamp'] = Date.now()

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

export default service
